var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Form from '../../templates/Form';
import Input from '../../atoms/Input';
import { FormRowDivider } from '../../templates/Form/Form';
import AlertText from '../../atoms/AlertText';
import { hanghae } from '@teamsparta/design-system';
var NewPasswordForm = function (_a) {
    var password = _a.password, setPassword = _a.setPassword, passwordDoubleCheck = _a.passwordDoubleCheck, setPasswordDoubleCheck = _a.setPasswordDoubleCheck, passwordWarning = _a.passwordWarning, label = _a.label, checkAlert = _a.checkAlert, onClickCta = _a.onClickCta;
    return (_jsxs(_Fragment, { children: [_jsxs(Form, __assign({ label: label, checkAlert: checkAlert }, { children: [_jsx(Input, { value: password, setValue: setPassword, placeHolder: '6자 이상, 숫자와 영문자 조합', type: 'password', isEmbedded: true }), _jsx(FormRowDivider, {}), _jsx(Input, { value: passwordDoubleCheck, setValue: setPasswordDoubleCheck, placeHolder: '비밀번호 재입력', type: 'password', isEmbedded: true, checkAlert: checkAlert, onClickCta: onClickCta })] })), _jsx(AlertText, __assign({ isShow: !!passwordWarning, color: hanghae.red100 }, { children: passwordWarning }))] }));
};
export default NewPasswordForm;
//# sourceMappingURL=NewPasswordForm.js.map